import { Link } from '@tanstack/react-router';
import { Icon } from '@sentinel/ui';
import { Trans, useTranslation } from 'react-i18next';
import type { NavBadge } from './nav-badges';
import type { NavEntry } from './navigation';

interface Props {
  entry: NavEntry;
  active: boolean;
  /** PCA rows: bigger, with the short line under the label. */
  large: boolean;
  badge?: NavBadge | undefined;
}

/** One entry of the sidebar. «Active» comes from the navigation, not from the router alone:
 *  an entry lights up on its other pages too (`also`). */
export function NavItem({ entry, active, large, badge }: Props) {
  const { t } = useTranslation();
  return (
    <Link
      to={entry.to}
      activeOptions={{ exact: true }}
      activeProps={{}}
      aria-current={active ? 'page' : undefined}
    >
      <Icon name={entry.icon} size={large ? 18 : 15} />
      <span className="lbl">
        {t(`shell.nav.entries.${entry.key}`)}
        {large && entry.sub === true ? (
          <span className="sub">{t(`shell.nav.subs.${entry.key}`)}</span>
        ) : null}
      </span>
      {badge === undefined || entry.badge === undefined ? null : (
        <span className="r">
          <span className={['bdg', badge.tone].join(' ')}>
            <Trans
              i18nKey={`shell.nav.badges.${entry.badge}`}
              count={badge.count}
              components={{ b: <b /> }}
            />
          </span>
        </span>
      )}
    </Link>
  );
}
